// 环境变量定义
// 所有环境统一使用 /api，由代理转发到 http://codercba.com:5000/
// - 开发环境：vue.config.js devServer.proxy
// - 生产环境：Cloudflare Pages Functions (functions/api/[[path]].js)

const BASE_URL = '/api'
const TIME_OUT = 10000

export { BASE_URL, TIME_OUT }
